import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Card = styled.div`
  margin-bottom: 0.3rem;
  border: "0";
  color: black;
  background: white;
  width: 100%;
  height: 100%;
  box-shadow: 0 1px 4px 0 grey;
  position: relative;
  display: flex;
  flex-direction: column;
  word-wrap: "break-word";
  font-size: ".875rem";
  border-radius: 6px;
`;
const Data1 = styled.div`
  font-size: 1.3rem;
  font-weight: 700;
  opacity: 0.87;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Logo = styled.div`
  font-size: 1rem;
  font-weight: 500;
  margin-left: 0.2rem;
  opacity: 0.9;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Data2 = styled.div`
  font-size: 0.9rem;
  font-weight: 600;
  margin-left: 1px;
  opacity: 0.6;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const DataContainer = styled.div`
  margin-left: 0.5rem;
  //margin-right: -0.2rem;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
`;

const DataList = styled.div`
  height: 5rem;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: row;
  white-space: nowrap;
  margin: 0rem 0.5rem;
  flex: ${(props) => props.size};
`;

const media = {
  xs: (styles) => `
  @media only screen and (max-width: 480px) { ${styles} 
  }
  `,
};

function CustomSubCP(props) {
  return (
    <>
      <Card>
        <DataList>
          <Logo>{props.logo}</Logo>
          <DataContainer>
            <Data1>{props.number}</Data1>
            <Data2>{props.name}</Data2>
          </DataContainer>
        </DataList>
      </Card>
    </>
  );
}

CustomSubCP.propTypes = {
  dataGroup: PropTypes.string,
  dataMeter: PropTypes.string,
  dataCounter: PropTypes.string,
  dataActive: PropTypes.string,
  dataInactive: PropTypes.string,
};

export default CustomSubCP;
